export const getErrors = (...messages) => {
    return {messages}
}